//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { uid } from "quasar";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import QAuModelPicker from "@/components/Generics/ModelPicker/qAuModelPicker.vue";
import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import setConditions from "@/components/Diagrams/config/set-conditions.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

export default {
    components: {
        AQModal,
        AQInput,
        AQButton,
        QAuModelPicker,
        AQChip,
        AQToggle,
        AQBadge,
        AQListBtn,
        setConditions,
        AQDialog,
        AQCard
    },
    props: {
        blockDetails: { type: Object, default: () => {} },
        dataModelConstraint: { type: String, default: "" },
        disableSelection: { type: Boolean, default: false }
    },
    data() {
        return {
            showModal: true,
            selectAttributeModal: false,
            blockName: "",
            selection: [],
            selectionSort: "",
            temporarySelection: [],
            hover: null,
            blockNameError: false,
            sortingToggle: false,
            sortSelectedAttribute: "",
            fromSorting: false,
            modalOrigin: "",
            direction: "DESC",
            buttonTypeDesc: "link",
            buttonTypeAsc: "link",
            blockConditions: {},
            initialConditions: {},
            fromRepeatable: true,
            selectionSortError: false,
            basePath: "",
            extendParent: false,
            deleteEditListDialog: false,
            fromDelete: false,
            buttonsListToHide: ["edit", "more", "copy", "download"]
        };
    },
    computed: {
        disableAddCondBtn() {
            return !this.selection.length;
        },
        sendBasePath() {
            let basePath = null;
            if (this.modalOrigin === "sorting") {
                basePath = `m_${this.selection[0]}`;
            } else if (this.dataModelConstraint && this.modalOrigin === "settings") {
                basePath = `m_${this.dataModelConstraint}`;
            }
            return basePath;
        },
        getModelPicker() {
            let model = this.selection;
            if (this.modalOrigin === "sorting") {
                model = this.selectionSort;
            }
            return model;
        },
        hasPrimary() {
            return {
                label: this.$t("generic.done"),
                disabled: false
            };
        },
        done() {
            return {
                label: this.$t("generic.done"),
                disabled: false
            };
        },
        getModePicker() {
            let mode = "froala";
            if (this.modalOrigin === "sorting") {
                mode = "b";
            }
            return mode;
        }
    },
    watch: {
        blockDetails: {
            handler(newValue) {
                if (newValue && Object.keys(newValue).length) {
                    this.blockName = newValue.name;
                    this.selection = newValue.selection;
                    if (this.selection && this.selection.length) {
                        this.selectionSort = newValue.sortBy;
                    }
                    this.direction = newValue.direction || "DESC";
                    this.blockConditions = newValue.conditions;
                    this.basePath = `m_${this.selection[0]}` || "";
                    if (this.selectionSort) {
                        this.sortingToggle = true;
                    }
                    if (this.direction === "ASC") {
                        this.buttonTypeAsc = "primary";
                    } else {
                        this.buttonTypeDesc = "primary";
                    }
                }
            },
            immediate: true
        },
        selection: {
            handler(newValue) {
                this.selectionSort = "";
                this.blockConditions = {};
                this.basePath = newValue.length ? `m_${this.selection[0]}` : "";
            }
        }
    },
    mounted() {
        this.initialConditions = JSON.parse(JSON.stringify(this.blockConditions));
    },
    methods: {
        actionsRepeatable(event) {
            if (event === "primary") {
                if (this.sortingToggle && !this.selectionSort) {
                    this.selectionSortError = true;
                } else {
                    this.selectionSortError = false;
                    const repeatableDetails = JSON.parse(JSON.stringify(this.blockDetails));
                    repeatableDetails.name = this.blockName;
                    repeatableDetails.selection = this.selection;
                    repeatableDetails.sortBy = this.selectionSort;
                    repeatableDetails.direction = this.direction;
                    const copyConditions = [];
                    if (this.blockConditions.conditions && this.blockConditions.conditions.length) {
                        for (let i = 0; i < this.blockConditions.conditions.length; i++) {
                            if (this.blockConditions.conditions[i].val1.value) {
                                if (this.blockConditions.conditions[i].val2.type !== "LOC") {
                                    if (this.blockConditions.conditions[i].val2.value) {
                                        copyConditions.push(this.blockConditions.conditions[i]);
                                    }
                                } else {
                                    copyConditions.push(this.blockConditions.conditions[i]);
                                }
                            }
                        }
                        this.blockConditions.conditions = copyConditions;
                        const conditionsLength = this.blockConditions.conditions.length;
                        if (conditionsLength && this.blockConditions.conditions[conditionsLength - 1].logicOperatorAfter) {
                            this.blockConditions.conditions[conditionsLength - 1].logicOperatorAfter = null;
                        }
                    }
                    repeatableDetails.conditions = this.blockConditions.conditions;
                    repeatableDetails.statement = this.blockConditions.statement;
                    if (this.blockDetails.uuid) {
                        repeatableDetails.uuid = this.blockDetails.uuid;
                    } else {
                        repeatableDetails.uuid = uid();
                    }
                    if (!this.blockName.trim()) {
                        this.blockNameError = true;
                    } else {
                        this.blockNameError = false;
                        this.$emit("sendParamsInFroala", repeatableDetails);
                        this.$emit("input", false);
                    }
                    this.$root.$emit("showCheckedSaveBtn", false);
                }
            } else if (event === "close") {
                const repeatableDetails = JSON.parse(JSON.stringify(this.blockDetails));
                repeatableDetails.conditions = this.initialConditions.conditions;
                repeatableDetails.statement = this.initialConditions.statement;
                this.$emit("sendParamsInFroala", repeatableDetails);
                this.$emit("input", false);
            }
        },
        dialogConfirmAction(action) {
            if (action === "ok") {
                if (this.fromDelete) {
                    this.sortingToggle = false;
                    this.selection = [];
                    this.selectionSort = "";
                    this.blockConditions = {};
                } else {
                    this.selection = this.temporarySelection.length ? this.temporarySelection : this.selection;
                    this.selectAttributeModal = false;
                    this.temporarySelection = [];
                }
            } else {
                this.deleteEditListDialog = false;
            }
        },
        resetSort() {
            if (!this.sortingToggle) {
                this.direction = "";
                this.selectionSort = "";
            }
        },
        selectDirection(fromDesc) {
            if (fromDesc) {
                this.direction = "DESC";
                this.buttonTypeDesc = "primary";
                this.buttonTypeAsc = "link";
            } else {
                this.direction = "ASC";
                this.buttonTypeAsc = "primary";
                this.buttonTypeDesc = "link";
            }
        },
        openSortPicker() {
            this.modalOrigin = "sorting";
            this.selectAttributeModal = true;
        },
        addListAttribute() {
            this.modalOrigin = "settings";
            this.selectAttributeModal = true;
        },
        actionsSelectAttribute(event) {
            if (event === "primary") {
                if (this.modalOrigin === "settings") {
                    if (this.selection.length && this.temporarySelection.length) {
                        this.fromDelete = false;
                        this.deleteEditListDialog = true;
                    } else {
                        this.selection = this.temporarySelection.length ? this.temporarySelection : this.selection;
                        this.selectAttributeModal = false;
                        this.temporarySelection = [];
                    }
                } else {
                    this.selectionSort = this.temporarySelection.length ? this.temporarySelection[0] : this.selectionSort;
                    this.selectAttributeModal = false;
                    this.temporarySelection = [];
                }
            } else if (event === "close") {
                this.selectAttributeModal = false;
                this.temporarySelection = [];
            }
        },
        deleteSelection() {
            this.fromDelete = true;
            this.deleteEditListDialog = true;
        },
        addBinIcon() {
            this.hover = true;
        },
        removeBinIcon() {
            this.hover = null;
        },
        onModelSelect(selection) {
            const model = [];
            selection.forEach(entry => {
                if (entry.formatted.startsWith("m_")) {
                    model.push(entry.key);
                }
            });
            this.temporarySelection = [...model];
        },
        setInnerContent(className) {
            const classArr = className.split(".");
            classArr.pop();
            const innerContent = classArr.join(".");
            return innerContent;
        },
        setContent(fullName) {
            return fullName.split(".").pop();
        }
    }
};
